import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { MODO, validarEntorno } from "@/reclutamiento/modo";

// Tras un despliegue nuevo, los pedazos viejos pueden no existir: se recarga una vez.
window.addEventListener("vite:preloadError", () => {
  const key = "chunk-reload";
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    window.location.reload();
  }
});

async function proveedores() {
  if (MODO === "supabase") {
    const [{ getAuthProvider, getDataProvider }, { PuertaInterna }] = await Promise.all([
      import("@/components/atomic-crm/providers/supabase"),
      import("@/interna/PuertaInterna"),
    ]);
    return { dataProvider: getDataProvider(), authProvider: getAuthProvider(), Puerta: PuertaInterna };
  }
  // Demo: solo aquí se toca localStorage con la semilla.
  const [{ authProvider }, { crearProveedorDemo }] = await Promise.all([
    import("@/components/atomic-crm/providers/fakerest"),
    import("@/reclutamiento/demo/proveedorDemo"),
  ]);
  // En demo no hay usuarios de cliente que filtrar: la puerta deja pasar.
  return { dataProvider: crearProveedorDemo(), authProvider, Puerta: null };
}

const raiz = createRoot(document.getElementById("root")!);
const error = validarEntorno();
if (error) {
  raiz.render(
    <div style={{ maxWidth: 560, margin: "15vh auto", fontFamily: "system-ui", padding: 16 }}>
      <h1>Falta configuración</h1>
      <p>{error}</p>
    </div>,
  );
} else {
  proveedores().then(({ dataProvider, authProvider, Puerta }) =>
    raiz.render(
      <StrictMode>
        {Puerta ? (
          <Puerta>
            <App dataProvider={dataProvider} authProvider={authProvider} />
          </Puerta>
        ) : (
          <App dataProvider={dataProvider} authProvider={authProvider} />
        )}
      </StrictMode>,
    ),
  );
}
